<div>
  <span class="dont-break-out">{{metadataRepresentation.getValue()}}</span>
</div>
